export default __webpack_public_path__ + "static/media/class-data.aff91c47.svg";